import {
    GiftCardProviders,
    IThirdPartyGiftCardType,
    ThirdPartyGiftCardProviders,
} from '@raskrask-dk/bookingflow-state-machine'
import { useEffect, useState } from 'react'
import { useBFSM } from '../../contexts/bfsmContext'
import { useAppDispatch } from '../../redux/hooks'
import { setIsLoading } from '../../redux/reducers/appSettings'

export interface ReactThirdPartyGiftCardType {
    provider: ThirdPartyGiftCardProviders
    label: string
    id: number
}

export type ProviderOption = { value: GiftCardProviders; label: string }

export const useDetails = (): {
    thirdPartyGiftCardTypes: ReactThirdPartyGiftCardType[]
    providerOptions: ProviderOption[]
} => {
    const [BFSM] = useBFSM()
    const dispatch = useAppDispatch()
    const [thirdPartyGiftCardTypes, setThirdPartyGiftCardTypes] = useState<
        ReactThirdPartyGiftCardType[]
    >([])

    useEffect(() => {
        const getData = async () => {
            try {
                dispatch(setIsLoading(true))
                const thirdPartyGiftCards =
                    (await BFSM.repo.getThirdPartyGiftCardTypes()) as IThirdPartyGiftCardType[]
                setThirdPartyGiftCardTypes(
                    getThirdPartyGiftCardTypes(thirdPartyGiftCards)
                )
                dispatch(setIsLoading(false))
            } catch (err) {
                // TODO! Unhandled error. What should happen here?
                dispatch(setIsLoading(false))
            }
        }
        getData()
    }, [])

    const providerOptions: ProviderOption[] = [
        { value: 'RaskRask', label: 'RaskRask' },
        ...thirdPartyGiftCardTypes.reduce((r, t) => {
            const i = r.find((e) => e.value === t.provider)
            if (i) return r
            r.push({ value: t.provider, label: t.provider })
            return r
        }, [] as ProviderOption[]),
    ]

    return { thirdPartyGiftCardTypes, providerOptions }
}

const getThirdPartyGiftCardTypes = (
    giftCards: IThirdPartyGiftCardType[]
): ReactThirdPartyGiftCardType[] => {
    const output: ReactThirdPartyGiftCardType[] = []
    giftCards.forEach((giftCard) => {
        const partnerName = giftCard.partnerName as ThirdPartyGiftCardProviders
        const thisCard: ReactThirdPartyGiftCardType = {
            provider: partnerName,
            id: giftCard.partnerGiftCardTypeID,
            label: giftCard.giftCardType,
        }
        output.push(thisCard)
    })
    return output
}
